var _ellipse, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStaff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.9696,
    cy: 7.19645,
    rx: 6.18254,
    ry: 6.19645,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.98438 23.3951C1.98438 19.818 3.68652 16.6394 6.32332 14.6284M9.93411 12.8113C9.05065 13.0653 8.2128 13.4274 7.43573 13.8824C7.04927 14.1087 6.67785 14.358 6.32332 14.6284M24.0168 23.3951C24.0168 19.818 22.3146 16.6394 19.6778 14.6284M16.067 12.8113C16.9505 13.0653 17.7883 13.4274 18.5654 13.8824C18.9519 14.1087 19.3233 14.358 19.6778 14.6284M12.8871 18.2626V23.3951M12.8871 18.2626L6.32332 14.6284M12.8871 18.2626L19.6778 14.6284",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaff);
export default __webpack_public_path__ + "static/media/Staff.08aa62d79291bc3aeac68c5974783bc6.svg";
export { ForwardRef as ReactComponent };